import React from 'react'
import { BookmarkPlus, ShoppingBag, ArrowRightLeft, FileText } from 'lucide-react'
import { MODE_THEME, type ShipmentMode } from './ui/mode-theme'

interface InhouseModeSelectorProps {
  shipmentMode: ShipmentMode
  onModeChange: (mode: ShipmentMode) => void
}

export function InhouseModeSelector({ shipmentMode, onModeChange }: InhouseModeSelectorProps) {
  const oldInvoiceTheme = MODE_THEME.old_invoice

  return (
    <div className="grid grid-cols-2 gap-2">
      <button
        type="button"
        onClick={() => onModeChange('reserve')}
        aria-pressed={shipmentMode === 'reserve'}
        className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-all ${
          shipmentMode === 'reserve'
            ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300'
            : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-amber-300'
        }`}
      >
        <BookmarkPlus className="h-4 w-4 flex-shrink-0" />
        <span className="font-medium text-xs sm:text-sm">Reserve</span>
      </button>
      <button
        type="button"
        onClick={() => onModeChange('pickup')}
        aria-pressed={shipmentMode === 'pickup'}
        className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-all ${
          shipmentMode === 'pickup'
            ? 'border-green-500 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300'
            : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-green-300'
        }`}
      >
        <ShoppingBag className="h-4 w-4 flex-shrink-0" />
        <span className="font-medium text-xs sm:text-sm">Pick Up</span>
      </button>
      <button
        type="button"
        onClick={() => onModeChange('transfer')}
        aria-pressed={shipmentMode === 'transfer'}
        className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-all ${
          shipmentMode === 'transfer'
            ? 'border-teal-500 bg-teal-50 dark:bg-teal-900/20 text-teal-700 dark:text-teal-300'
            : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-teal-300'
        }`}
      >
        <ArrowRightLeft className="h-4 w-4 flex-shrink-0" />
        <span className="font-medium text-xs sm:text-sm">Transfer</span>
      </button>
      <button
        type="button"
        onClick={() => onModeChange('old_invoice')}
        aria-pressed={shipmentMode === 'old_invoice'}
        className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-all ${
          shipmentMode === 'old_invoice'
            ? `${oldInvoiceTheme.border} ${oldInvoiceTheme.bg} ${oldInvoiceTheme.text}`
            : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-indigo-300'
        }`}
      >
        <FileText className="h-4 w-4 flex-shrink-0" />
        <span className="font-medium text-xs sm:text-sm">Old Invoice</span>
      </button>
    </div>
  )
}
